import { render, staticRenderFns } from "./NewJoineesList.vue?vue&type=template&id=f579e716&scoped=true&"
import script from "./NewJoineesList.vue?vue&type=script&lang=ts&"
export * from "./NewJoineesList.vue?vue&type=script&lang=ts&"
import style0 from "./NewJoineesList.vue?vue&type=style&index=0&id=f579e716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f579e716",
  null
  
)

component.options.__file = "NewJoineesList.vue"
export default component.exports